<template>
  <p>
    <printer-filament-label v-for="index in extrudersCount"
                            :key="index"
                            :ex="index"
                            :exCount="extrudersCount"
                            :filament="printer.filaments?(printer.filaments[index-1]||{}):{}"
                            :nozzle="nozzles[index-1]||null">
  </printer-filament-label>
</p>
</template>

<script>
  import {mapGetters} from 'vuex';
  import PrinterFilamentLabel from './PrinterFilamentLabel';
  export default {
    name: 'printer-filament-labels',
    props: ['printer'],
    components: {
      PrinterFilamentLabel
    },
    computed: {
      ...mapGetters(['getDualExtruders']),
      extrudersCount() {
        return this.getDualExtruders.indexOf(parseInt(this.printer.printer_type_id)) >= 0 ? 2 : 1;
      },
      nozzles() {
        if (this.printer.nozzles) {
          try {
            return JSON.parse(this.printer.nozzles);
          } catch (e) {
            console.log('Failed to parse printer nozzles: ' + this.printer.nozzles);
          }
        }

        return [];
      }
    }
  }
</script>